import React from "react";

interface Props {
  stepCount: number;
  title: string;
}

export default function PanelHeader(props: Props) {
  const { stepCount, title } = props;

  const CountLabel = () => {
    return (
      <div className="mt-1 w-6 h-6 rounded-full flex justify-center items-center bg-primaryRed text-white font-bold text-sm">
        {stepCount}
      </div>
    );
  };

  return (
    <div className="inline flex items-center">
      <CountLabel />
      <span className="ml-4 text-2xl font-bold">{title}</span>
    </div>
  );
}
